<template>
  <container
    :subHeaderTitle="headerTitle"
    :subHeaderText="headerText"
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="6" sm="8">
            <v-divider class="mb-8" />
            <div class="help-info">
              <span class="refund-date">{{ refundDate }}</span>
              <span class="refund-name">{{ refundName }}</span>
            </div>
            <v-divider class="my-8" />
            <div class="mt-12 mb-16 text-center">
              <v-btn class="result" rounded large depressed color="primary" @click.stop="$router.push({ name: 'Support' })">확인</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <!-- router Param 없을때 -->
    <v-dialog v-model="returnDialog" persistent max-width="290">
      <v-card>
        <v-card-text class="pt-8 text-center">
          <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
          <h4>정상적인 접근이 아닙니다.</h4>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="goReturn()">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";

.help-info {display: flex;justify-content: center;gap: 40px;color: #001523;font-size: 1rem;font-weight: 500;line-height: 30px;letter-spacing: -0.5px;text-align: left;
  @media (max-width: 600px) {flex-direction: column;align-items: flex-start;gap: 16px;}}

.refund-date, .refund-name {display: block;}
</style>

<script>
import Container from "@/pages/container/index.vue";
import RefundResult from "@/views/csCenter/RefundResult.vue";

export default {
  mixins: [RefundResult],
  name: "RefundResult",
  components: {
    Container
  },
  data() {
    return {
      headerTitle: "",
      headerText: "",
      refundDate: "",
      refundName: "입금자명: 핀브릿지 주식회사",
      returnDialog: false
    };
  },
  created() {
    this.headerTitle = this.$route.params.serviceType + '<br /><b>환불 신청</b>';
    this.headerText = '환불 신청이 완료되었습니다.';

    // 환불 날짜 계산
    const today = new Date();
    if (['금융사기방지', 'PASS세이프가드', '세이프가드_KT', '정보유출안심케어', 'PASS프라임', '전월세안심케어', '금융튜터'].includes(this.$route.params.serviceType)) {
      const twoBusinessDaysLater = this.addBusinessDays(today, 2);
      this.refundDate = `환불 예정 일자: ${twoBusinessDaysLater.getFullYear()}년 ${twoBusinessDaysLater.getMonth() + 1}월 ${twoBusinessDaysLater.getDate()}일`;
    }

    if (this.$route.params.serviceType === undefined){
      this.returnDialog = true
    }
  },
  mounted() {
    this.headerText = '환불 신청이 완료되었습니다.'
  },
  methods: {
    addBusinessDays(date, days) {
      let currentDate = new Date(date);
      let remainingDays = days;

      while (remainingDays > 0) {
        currentDate.setDate(currentDate.getDate() + 1);
        const dayOfWeek = currentDate.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          remainingDays -= 1;   // 주말은 제외 (0 = Sunday, 6 = Saturday)
        }
      }
      return currentDate;
    },
    goReturn() {
      this.$router.push({ name: "Support" });
    }
  }
};
</script>
